import { environments } from 'environments/environments'

const defaultUFContract = [
    { text: 'Arrendamento Mercantil', value: '1' },
    { text: 'Reserva de Domínio', value: '2' },
    { text: 'Alienação Fiduciária', value: '3' },
    { text: 'Penhor', value: '4' }
]

const { CONTRACT_CANCELLATION } = environments

const statusContrato = [
    { text: 'Registrado', value: 'REGISTRADO' },
    { text: 'Parcialmente Registrado', value: 'PARCIALMENTE_REGISTRADO' }
]

if (CONTRACT_CANCELLATION) {
    statusContrato.push(
        { text: 'Cancelado', value: 'CANCELADO' },
        { text: 'Baixado', value: 'BAIXADO' }
    )
}

export const optionsDefault = {
    uf: [
        { 'arial-label': 'Acre', text: 'AC', value: 'AC' },
        { 'arial-label': 'Alagoas', text: 'AL', value: 'AL' },
        { 'arial-label': 'Amapá', text: 'AP', value: 'AP' },
        { 'arial-label': 'Amazonas', text: 'AM', value: 'AM' },
        { 'arial-label': 'Bahia', text: 'BA', value: 'BA' },
        { 'arial-label': 'Ceará', text: 'CE', value: 'CE' },
        { 'arial-label': 'Distrito Federal', text: 'DF', value: 'DF' },
        { 'arial-label': 'Espírito Santo', text: 'ES', value: 'ES' },
        { 'arial-label': 'Goiás', text: 'GO', value: 'GO' },
        { 'arial-label': 'Maranhão', text: 'MA', value: 'MA' },
        { 'arial-label': 'Mato Grosso', text: 'MT', value: 'MT' },
        { 'arial-label': 'Mato Grosso do Sul', text: 'MS', value: 'MS' },
        { 'arial-label': 'Minas Gerais', text: 'MG', value: 'MG' },
        { 'arial-label': 'Pará', text: 'PA', value: 'PA' },
        { 'arial-label': 'Paraíba', text: 'PB', value: 'PB' },
        { 'arial-label': 'Paraná', text: 'PR', value: 'PR' },
        { 'arial-label': 'Pernambuco', text: 'PE', value: 'PE' },
        { 'arial-label': 'Piauí', text: 'PI', value: 'PI' },
        { 'arial-label': 'Rio de Janeiro', text: 'RJ', value: 'RJ' },
        { 'arial-label': 'Rio Grande do Norte', text: 'RN', value: 'RN' },
        { 'arial-label': 'Rio Grande do Sul', text: 'RS', value: 'RS' },
        { 'arial-label': 'Rondônia', text: 'RO', value: 'RO' },
        { 'arial-label': 'Roraima', text: 'RR', value: 'RR' },
        { 'arial-label': 'Santa Catarina', text: 'SC', value: 'SC' },
        { 'arial-label': 'São Paulo', text: 'SP', value: 'SP' },
        { 'arial-label': 'Sergipe', text: 'SE', value: 'SE' },
        { 'arial-label': 'Tocantins', text: 'TO', value: 'TO' },
        {
            'arial-label': '-',
            text: '-',
            value: '-',
            hidden: true,
            disabled: true
        }
    ],

    ufContract: [
        { 'arial-label': 'Acre', text: 'AC', value: 'AC' },
        { 'arial-label': 'Amapá', text: 'AP', value: 'AP' },
        { 'arial-label': 'Bahia', text: 'BA', value: 'BA' },
        { 'arial-label': 'Distrito Federal', text: 'DF', value: 'DF' },
        { 'arial-label': 'Espírito Santo', text: 'ES', value: 'ES' },
        { 'arial-label': 'Minas Gerais ', text: 'MG', value: 'MG' },
        { 'arial-label': 'Mato Grosso do Sul', text: 'MS', value: 'MS' },
        { 'arial-label': 'Mato Grosso', text: 'MT', value: 'MT' },
        { 'arial-label': 'Paraíba', text: 'PB', value: 'PB' },
        { 'arial-label': 'Paraná', text: 'PR', value: 'PR' },
        { 'arial-label': 'Pernambuco', text: 'PE', value: 'PE' },
        { 'arial-label': 'Piaui ', text: 'PI', value: 'PI' },
        { 'arial-label': 'Rio de Janeiro', text: 'RJ', value: 'RJ' },
        { 'arial-label': 'Rio Grande do Sul', text: 'RS', value: 'RS' },
        { 'arial-label': 'Rio Grande do Norte', text: 'RN', value: 'RN' },
        { 'arial-label': 'Roraima', text: 'RR', value: 'RR' },
        { 'arial-label': 'Santa Catarina', text: 'SC', value: 'SC' },
        { 'arial-label': 'São Paulo', text: 'SP', value: 'SP' },
        { 'arial-label': 'Tocantins', text: 'TO', value: 'TO' }
    ].sort((a, b) => a.text.localeCompare(b.text)),

    ufSearchContract: [
        { 'arial-label': 'Acre', text: 'AC', value: 'AC' },
        { 'arial-label': 'Amapá', text: 'AP', value: 'AP' },
        { 'arial-label': 'Bahia', text: 'BA', value: 'BA' },
        { 'arial-label': 'Espírito Santo', text: 'ES', value: 'ES' },
        { 'arial-label': 'Minas Gerais ', text: 'MG', value: 'MG' },
        { 'arial-label': 'Mato Grosso do Sul', text: 'MS', value: 'MS' },
        { 'arial-label': 'Mato Grosso', text: 'MT', value: 'MT' },
        { 'arial-label': 'Paraná', text: 'PR', value: 'PR' },
        { 'arial-label': 'Rio de Janeiro', text: 'RJ', value: 'RJ' },
        { 'arial-label': 'Rio Grande do Sul', text: 'RS', value: 'RS' },
        { 'arial-label': 'Roraima', text: 'RR', value: 'RR' },
        { 'arial-label': 'São Paulo', text: 'SP', value: 'SP' },
        { 'arial-label': 'Tocantins', text: 'TO', value: 'TO' }
    ].sort((a, b) => a.text.localeCompare(b.text)),

    typeAddress: [
        { text: 'Matriz', value: 'MATRIZ' },
        { text: 'Comercial', value: 'COMERCIAL' },
        { text: 'Financeiro', value: 'FINANCEIRO' }
    ],

    type: defaultUFContract,
    typeBA: defaultUFContract.concat([{ text: 'Consorcio', value: '6' }]),
    typeMS: defaultUFContract.concat([
        { text: 'Cédula de Crédito', value: '5' },
        { text: 'Consorcio', value: '6' }
    ]),
    booleanType: [
        { text: 'Sim', value: 'SIM' },
        { text: 'Não', value: 'NAO' }
    ],
    doc: [
        { text: 'CPF', value: 'CPF' },
        { text: 'CNPJ', value: 'CNPJ' }
    ],
    operation: [
        { text: 'Todos', value: 'TODOS' },
        { text: 'Inclusão de Registro', value: 'INCLUSAO_REGISTRO' },
        { text: 'Alteração de Registro', value: 'ALTERACAO_REGISTRO' },
        { text: 'Inclusão de Aditivo', value: 'INCLUSAO_ADITIVO' },
        { text: 'Alteração de Aditivo', value: 'ALTERACAO_ADITIVO' }
    ],
    operationWithoutALL: [
        { text: 'Inclusão de Registro', value: 'INCLUSAO_REGISTRO' },
        { text: 'Alteração de Registro', value: 'ALTERACAO_REGISTRO' },
        { text: 'Inclusão de Aditivo', value: 'INCLUSAO_ADITIVO' },
        { text: 'Alteração de Aditivo', value: 'ALTERACAO_ADITIVO' }
    ],
    statusOperacao: [
        { text: 'Todos', value: 'TODOS' },
        { text: 'Registrado', value: 'REGISTRADO' },
        { text: 'Recusado', value: 'RECUSADO' }
    ],
    origin: [
        { text: 'Api', value: 'API' },
        { text: 'Lote', value: 'LOTE' },
        { text: 'Send', value: 'SEND' },
        { text: 'Tela', value: 'TELA' }
    ],
    statusContrato,
    especieVeiculo: [
        { text: 'Não Informado', value: 0 },
        { text: 'Passageiro', value: 1 },
        { text: 'Carga', value: 2 },
        { text: 'Misto', value: 3 },
        { text: 'Corrida', value: 4 },
        { text: 'Tração', value: 5 },
        { text: 'Especial', value: 6 },
        { text: 'Coleção', value: 7 }
    ],

    agenteCategorizacao: [
        { text: 'Bancos', value: 'BANCOS' },
        { text: 'Financeiras', value: 'FINANCEIRAS' },
        { text: 'Empresas de Leasing', value: 'EMPRESAS_LEASING' },
        {
            text: 'Administradoras de Consórcios',
            value: 'ADMINISTRADORAS_CONSORCIOS'
        },
        { text: 'Despachantes', value: 'DESPACHANTES' }
    ],
    statusRegistrationFee: [
        {
            text: 'Ativo',
            value: true
        },
        {
            text: 'Inativo',
            value: false
        }
    ],
    tipoAditivo: [
        {
            text: 'Substituição de Garantia',
            value: 'SUBSTITUICAO_GARANTIA'
        },
        {
            text: 'Cessão de Direito do Devedor',
            value: 'CESSAO_DIREITO_DEVEDOR'
        },
        {
            text: 'Cessão do Direito do Credor',
            value: 'CESSAO_DIREITO_CREDOR'
        }
    ],
    statusNotifications: [
        {
            value: 'TODAS',
            text: 'Todas'
        },
        {
            value: 'LIDAS',
            text: 'Lidas'
        },
        {
            value: 'NAO_LIDAS',
            text: 'Não Lidas'
        }
    ]

}
